import { render, staticRenderFns } from "./Voucher.vue?vue&type=template&id=05e23c8d&scoped=true&"
import script from "./Voucher.vue?vue&type=script&lang=js&"
export * from "./Voucher.vue?vue&type=script&lang=js&"
import style0 from "./Voucher.vue?vue&type=style&index=0&id=05e23c8d&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../var/task/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "05e23c8d",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/var/task/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('05e23c8d')) {
      api.createRecord('05e23c8d', component.options)
    } else {
      api.reload('05e23c8d', component.options)
    }
    module.hot.accept("./Voucher.vue?vue&type=template&id=05e23c8d&scoped=true&", function () {
      api.rerender('05e23c8d', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "tmp/tmp-2hZPLJb8rdG3R/JS/comp/Voucher.vue"
export default component.exports